'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product19__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.oq;
      break;
    }
    case 1: {
      return $thiz.oB;
      break;
    }
    case 2: {
      return $thiz.oC;
      break;
    }
    case 3: {
      return $thiz.oD;
      break;
    }
    case 4: {
      return $thiz.oE;
      break;
    }
    case 5: {
      return $thiz.oF;
      break;
    }
    case 6: {
      return $thiz.oG;
      break;
    }
    case 7: {
      return $thiz.oH;
      break;
    }
    case 8: {
      return $thiz.oI;
      break;
    }
    case 9: {
      return $thiz.or;
      break;
    }
    case 10: {
      return $thiz.os;
      break;
    }
    case 11: {
      return $thiz.ot;
      break;
    }
    case 12: {
      return $thiz.ou;
      break;
    }
    case 13: {
      return $thiz.ov;
      break;
    }
    case 14: {
      return $thiz.ow;
      break;
    }
    case 15: {
      return $thiz.ox;
      break;
    }
    case 16: {
      return $thiz.oy;
      break;
    }
    case 17: {
      return $thiz.oz;
      break;
    }
    case 18: {
      return $thiz.oA;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 18)"));
    }
  }
}
export { $f_s_Product19__productElement__I__O as $f_s_Product19__productElement__I__O };
